<template>
  <header id="desktopHeader" class="desktopHeader">
    <div class="flex justify-between">
      <DesktopHeaderContent :isSplitPanel="isSplitPanel" />
    </div>
  </header>
</template>

<script setup lang="ts">
import DesktopHeaderContent from '../content/DesktopHeaderContent.vue';

defineProps({
  isSplitPanel: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="css">
@reference "tailwindcss";

@layer app {
  .desktopHeader {
    @apply px-0 pt-4 pb-6;
  }
}
</style>
<style lang="css">
@layer app {
  .splitview .focus-area.focused .desktopHeader {
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }

  .splitview .focus-area .desktopHeader {
    opacity: 0.7;
  }
}
</style>
